import {Typography} from 'components/Typography';
import {useAddProductInCart} from 'hooks/product/useAddProductInCart';
import {FC} from 'react';
import classNames from 'classnames';
import style from 'modules/home/widgets/TopBannersBlock/style.module.scss';
import {NEXT_PUBLIC_WINTER_DESIGN} from 'core/helpers/env';
import {ButtonNew} from 'components/ButtonNew';

export const ProductBuyStickyCartButton: FC = () => {
    const handleClick = useAddProductInCart();

    return (
        <div>
            <ButtonNew
                isStretched={true}
                onClick={() => handleClick()}
                variant={'large'}
                // NEW_YEAR_2026
                isWinterDesign={true}
                className={classNames(style.bannerBtn, {
                    ['pdp-sticky-buy-block-button-winter-design']: NEXT_PUBLIC_WINTER_DESIGN,
                })}
            >
                <Typography variant={'button-14-m-cl'}>В корзину</Typography>
            </ButtonNew>
        </div>
    );
};
